module.exports = __webpack_public_path__ + "static/img/part1.a464041.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/news2/part1.png
// module id = 9fiQ
// module chunks = 7